<template>
  <b-modal
    id="modal-bulk"
    title="Bulk Input Kas Virtual"
    size="md"
    centered
    hide-footer
    :no-close-on-backdrop="isLoading"
    :no-close-on-esc="isLoading"
    :hide-header-close="isLoading"
    @hidden="resetModal"
  >
    <div
      v-if="!file"
      class="upload-zone text-center p-4 mb-3"
      :class="{ 'dragging': isDragging }"
      @dragover.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      @drop.prevent="handleDrop"
      @click="triggerFileInput"
    >
      <i class="fa fa-cloud-upload fa-3x text-muted mb-2"></i>
      <h6 class="font-weight-bold">Upload File Excel / CSV</h6>
      <p class="text-muted small mb-0">
        Klik atau drag file ke sini
      </p>

      <b-form-file
        ref="fileInputRef"
        v-model="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        class="d-none"
        plain
      ></b-form-file>
    </div>

    <div v-else class="file-preview-card p-3 mb-4 rounded border d-flex align-items-center justify-content-between bg-light">
      <div class="d-flex align-items-center overflow-hidden">
        <div class="icon-wrap bg-success text-white rounded p-2 mr-3">
          <i class="fa fa-file-excel-o fa-lg"></i>
        </div>
        <div class="text-truncate">
          <h6 class="mb-0 text-truncate" :title="file.name">{{ file.name }}</h6>
          <small class="text-muted">{{ (file.size / 1024).toFixed(2) }} KB</small>
        </div>
      </div>
      
      <b-button
        variant="outline-danger"
        size="sm"
        class="ml-2 btn-icon"
        :disabled="isLoading"
        @click="file = null"
      >
        <i class="fa fa-times"></i>
      </b-button>
    </div>

    <div class="d-flex justify-content-end border-top pt-3">
      <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('modal-bulk')" :disabled="isLoading">
        Batal
      </b-button>
      
      <b-button 
        variant="primary" 
        @click="submitFile" 
        :disabled="!file || isLoading"
      >
        Simpan File{{ isLoading ? '....' : '' }}
      </b-button>
    </div>

  </b-modal>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      file: null,
      isDragging: false,
    };
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInputRef.$el.click();
    },
    handleDrop(e) {
      this.isDragging = false;
      const droppedFiles = e.dataTransfer.files;
      if (droppedFiles.length) {
        this.file = droppedFiles[0];
      }
    },
    submitFile() {
      if (this.file) {
        this.$emit('on-file-selected', this.file);
      }
    },
    resetModal() {
      this.file = null;
      this.isDragging = false;
    }
  }
};
</script>

<style scoped>
.upload-zone {
  border: 2px dashed #ced4da;
  border-radius: 8px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s;
}
.upload-zone:hover, .upload-zone.dragging {
  border-color: #007bff;
  background-color: #e9ecef;
}
.icon-wrap {
  width: 40px; height: 40px;
  display: flex; align-items: center; justify-content: center;
}
.btn-icon {
  width: 30px; height: 30px; padding: 0;
  display: flex; align-items: center; justify-content: center; border-radius: 50%;
}
</style>